var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x"},[_c('div',{staticClass:"y"},[_c('div'),_c('div',{attrs:{"id":"content-body"}},[_c('div',{staticClass:"content-body-title"},[_c('div',[_vm._v(_vm._s(_vm.date))]),_c('div',[_vm._v("星期"+_vm._s(_vm.wdy[_vm.moment(_vm.date).weekday()]))])]),_c('div',{staticClass:"content-body-main"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }